import { render, staticRenderFns } from "./UserNameSettings.vue?vue&type=template&id=fca1f736&"
import script from "./UserNameSettings.vue?vue&type=script&lang=js&"
export * from "./UserNameSettings.vue?vue&type=script&lang=js&"
import style0 from "./UserNameSettings.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VForm,VIcon,VTextField})
